import classnames from 'classnames';

import styles from './menuHeader.module.scss';

type MenuHeaderProps = {
  /** Extra classnames */
  className?: string;
  /** Title */
  title: string;
  /** IsMenuOpen */
  isMenuOpen: boolean;
};

export const MenuHeader = ({
  title,
  isMenuOpen,
  className,
}: MenuHeaderProps) => {
  return (
    <h3
      className={classnames(
        {
          [styles.root]: true,
          [styles.rootCollapsed]: !isMenuOpen,
        },
        className,
      )}
    >
      {title}
    </h3>
  );
};
